/* Stienhardt - Affirm "as low as $X/mo" on the diamond PDP (2026-06-27)
   Mirrors the working step-3 widget (snippets/product-final-template.liquid):
   builds <p class="affirm-as-low-as" data-amount=CENTS>, lets affirm.js fill it,
   removes the "0% APR" badge, relabels the trigger to "Learn More".
   All diamonds (not lab-only). Revert = remove this file + its <script> + CSS. */
(function () {
  'use strict';
  var SRC = (window._affirm_config && _affirm_config.script) || 'https://cdn1.affirm.com/js/v2/affirm.js';
  function priceEl(){ return document.querySelector('.price__on-sale, .price__regular'); }
  function cents(){
    var p = priceEl(); if(!p) return null;
    var m = (p.textContent||'').replace(/[^0-9.]/g,''); if(!m) return null;
    var v = parseFloat(m); if(!(v>0)) return null;
    return Math.round(v*100);
  }
  function ensureAffirm(cb){
    if(window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function'){ cb(); return; }
    function wait(){ try{ affirm.ui.ready(function(){ cb(); }); }catch(e){ setTimeout(cb,600); } }
    var ex = document.querySelector('script[src*="affirm.com/js/v2/affirm"]');
    if(ex){ wait(); }
    else{ var s=document.createElement('script'); s.async=true; s.src=SRC; s.onload=wait; (document.head||document.documentElement).appendChild(s); }
  }
  function cleanup(ap){
    if(!ap) return; var mo;
    function c(){
      if(mo) mo.disconnect();
      var b=ap.querySelector('.__apr_badge'); if(b&&b.parentNode) b.parentNode.removeChild(b);
      var a=ap.querySelector('.affirm-modal-trigger'); if(a){ a.textContent='Learn More'; a.setAttribute('aria-label','Learn more about Affirm financing (opens in modal)'); }
      for(var i=0;i<ap.childNodes.length;i++){ var n=ap.childNodes[i]; if(n.nodeType===3){ n.textContent=n.textContent.replace(/^\s*or\s+/i,''); } }
      if(mo) mo.observe(ap,{childList:true,subtree:true,characterData:true});
    }
    try{ mo=new MutationObserver(c); mo.observe(ap,{childList:true,subtree:true,characterData:true}); }catch(e){}
    c();
  }
  function build(){
    if(document.querySelector('.sp-da-affirm')) return true;
    var price = priceEl(); if(!price) return false;
    var amt = cents(); if(!amt) return false;
    var row = price.parentElement || price;
    var wrap = document.createElement('div'); wrap.className='sp-da-affirm';
    wrap.innerHTML = '<p class="affirm-as-low-as" data-page-type="product" data-amount="'+amt+'"></p>';
    if (row && row.appendChild) row.appendChild(wrap); else price.parentNode.insertBefore(wrap, price.nextSibling);
    ensureAffirm(function(){ try{ affirm.ui.refresh(); }catch(e){} cleanup(wrap.querySelector('.affirm-as-low-as')); });
    return true;
  }
  var n=0, iv=setInterval(function(){ n++; build(); if(n>80) clearInterval(iv); },200);
  var mp=document.getElementById('mainproduct'); if(mp) new MutationObserver(build).observe(mp,{childList:true,subtree:true});
})();
